module.exports = __webpack_public_path__ + "img/二星特级大师@2x.fc5a3937.png";